import {
  doGetQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { FUNDAMENTO_LEGAL_REGIME_TRIBUTACAO_II_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll(queryParams) {
  return doGetQCXRequest([
    FUNDAMENTO_LEGAL_REGIME_TRIBUTACAO_II_ENDPOINT,
    'obter',
  ], queryParams);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    FUNDAMENTO_LEGAL_REGIME_TRIBUTACAO_II_ENDPOINT,
    id
  ]);
}
